import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const cn = {
    navbar: {
        'home': '首页',
        'blog': '博客',
        'language': '选择语言'
    },
    pageTitle: {
        'index': 'G-Lab在线小工具',
        'timeClac': '时间计算器',
        'idPhotoEditor': '证件照编辑器',
        'imgSplitter': '图片切分',
        'lifeRestart': '人生重开模拟器',
        'stopwatch': '秒表'
    },
    tools: {
        timeClac: {
            'introductionSimple': '计算两个时间点之间的时间差，可按不同时间层级汇总显示计算结果。',
            'introduction': '计算两个时间点之间的时间差，可按不同时间层级汇总显示计算结果，并且还可在不同时间层级进行调整再计算。可用于工时、纪念日和特定日期间隔的计算。',
            'startZone': '起始',
            'finshZone': '结束',
            'otpZone': '调整',
            'startDate': '起始日期',
            'finshDate': '结束日期',
            'datePlaceholder': '选择日期',
            'startTime': '起始时间',
            'finshTime': '结束时间',
            'timePlaceholder': '选择时间',
            'more': '更多',
            'resultZone': '间隔',
            'totalZone': '分类总计',
            'optResultZone': '调整结果',
            'result': '间隔时间',
            'totalDays': '天数总计',
            'totalHours': '小时总计',
            'totalMinutes': '分钟总计',
            'totalSeconds': '秒总计',
            'dateRuleRequired': '请选择日期',
            'timeRuleRequired': '请选择时间',
            'year': '年',
            'month': '个月',
            'day': '天',
            'hour': '小时',
            'minute': '分',
            'second': '秒'
        },
        idPhotoEditor: {
            'introductionSimple': '。',
            'introduction': '。',
            'customize': '自定义',
            'standard': '标准',
            'width': '宽度',
            'height': '高度',
            'importImg': '导入图片',
            'reset': '重置',
            'cropImg': '裁剪图片',
            'scaleTip': '当前裁剪框设置超过原图实际尺寸，将对裁剪结果进行等比例放大，可能会导致图片清晰度降低！',
            'downloadTip': '裁剪成功，请等待下载！',
            standards: {
                '1': '1寸 25x35mm',
                '2': '2寸 35x50mm'
            }
        },
        imgSplitter: {
            'introductionSimple': '可以将图片切分成 n*m 份，可用于制作社交平台的九宫格效果，也可用于动森贴图制作！',
            'introduction': '可以将图片切分成 n*m 份，可用于制作社交平台的九宫格效果，也可用于动森贴图制作！',
            'row': '行',
            'column': '列',
            'importImg': '导入图片',
            'splitImg': '切分图片',
            'saveAs': '保存类型',
            'toAcnlTool': '动森贴图编辑器'
        },
        lifeRestart: {
            'introductionSimple': '开启全新人生！'
        },
        stopwatch: {
            'introductionSimple': '实现区间计时，图表呈现计时情况。',
            'introduction': '实现区间计时，图表呈现计时情况。快捷键：“空格”为开始/停止；“S”为“记录”；“R”为复位。',
            'start': '开始',
            'record': '记录',
            'stop': '停止' ,
            'reset': '复位',
            'gap': '区间',
            'gapTime': '区间耗时',
            'totalTime': '总耗时',
            'pause': '暂停',
            'setInit': '初始',
            'editTime': '起始时间',
            'hour': '小时',
            'minute': '分',
            'second': '秒',
            'millisecond': '毫秒',
            'confirm': '确 定',
            'cancel': '取 消'
        }
    },
    components: {
        imgLoader: {
            tip1: '请将图片拖拽到此处 或 ',
            tip2: '选择图片',
            unsupportedErr: '您的浏览器不支持',
            imgTypeErr: '请选择图片文件'
        }
    },
    ...zhLocale
}

export default cn